import React from "react";
const LoadingComp = (props) => {
  const styleClass = props.small ? "" : "loading";

  return (
    <div className={styleClass}>
      {!props.small && <h3>Loading please wait...</h3>}
      <div>
        <span className="loader-bar">
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
        </span>
      </div>
    </div>
  );
};

export default LoadingComp;
